// Each market's mark as this page has seen it: every move, kept for a quarter of an hour, for the
// arena to draw. Raw integers at the market's scale held as numbers: for drawing, never money.

import { marks, type Mark } from "../state/market";

const KEEP_MS = 15 * 60_000;
/** Moves closer together than this fold into one point: the latest. */
const GRAIN_MS = 100;

export type Ticks = { t: number[]; v: number[] };

const held = new Map<number, Ticks>();
let seen: Record<number, Mark> = {};

function record() {
  const all = marks.get();
  const now = Date.now();
  for (const [key, mark] of Object.entries(all)) {
    const id = Number(key);
    if (seen[id] === mark || mark.source === "frozen") continue;
    const value = Number(mark.raw);
    if (!Number.isFinite(value) || value <= 0) continue;
    let series = held.get(id);
    if (!series) {
      series = { t: [], v: [] };
      held.set(id, series);
    }
    const last = series.t.length - 1;
    if (last >= 0 && now - (series.t[last] ?? 0) < GRAIN_MS) series.v[last] = value;
    else {
      series.t.push(now);
      series.v.push(value);
    }
    let cut = 0;
    while (cut < series.t.length && now - (series.t[cut] ?? now) > KEEP_MS) cut += 1;
    if (cut > 0) {
      series.t.splice(0, cut);
      series.v.splice(0, cut);
    }
  }
  seen = all;
}

marks.subscribe(record);
record();

/** The moves seen for a market, oldest first; undefined before the first. */
export const ticksOf = (instrumentId: number): Ticks | undefined => held.get(instrumentId);
